<template>
  <ul class="sidebar-menu">
    <router-link tag="li" class="pageLink saprator-bottom" to="/">
      <a>
        <i class="fa fa-home"></i>
        <span class="page">Home</span>
      </a>
    </router-link>

    <li class="header">Reports</li>

    <router-link tag="li" class="pageLink" to="/DashboardModule">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Dashboard</span>
      </a>
    </router-link>
    <!-- <router-link tag="li" class="pageLink" to="/Report">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Dashboard</span>
      </a>
    </router-link>-->
    <router-link tag="li" class="pageLink " to="/Report">
      <a>
        <i class="fa fa-line-chart"></i>
        <span class="page">Model Reports</span>
      </a>
    </router-link>
    <li></li>
    <router-link to="/DisplaySchedule" tag="li" class="pageLink saprator">
      <a>
        <i class="fa fa-hourglass-start"></i>
        <span class="page">Schedule</span>
      </a>
    </router-link>
    <li></li>
    <router-link to="/DTStatus" tag="li" class="pageLink">
      <a>
        <i class="fa fa-cubes"></i>
        <span class="page">DT Status</span>
      </a>
    </router-link>
  </ul>
</template>
<script>
export default {
  /*eslint-disable */
  name: 'SidebarMenu',
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}
.sidebar-menu li.pageLink:last-child {
  margin-top: 10px;
}
.sidebar-collapse .sidebar-menu li.pageLink:last-child {
  border-bottom: 1px solid RGBA(255, 255, 255, 0);
  border-top: 1px solid RGBA(255, 255, 255, 0);
}
.sidebar-menu li.pageLink:last-child {
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.treeview-title {
  z-index: 1;
}
.skin-blue .sidebar-menu > li.saprator {
  border-top: 2px solid RGBA(255, 255, 255, 0.5);
}
.skin-blue .sidebar-menu > li.saprator-bottom {
  border-bottom: 2px solid RGBA(255, 255, 255, 0.5);
}
.sidebar-collapse .skin-blue .sidebar-menu > li.header {
  border-top: 1px solid RGBA(255, 255, 255, 0);
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?f36971d8